import React from "react";

const PreEmiPopUp = ({ details = [] }) => {

    if (!details || details.length === 0) {
        return null;
    }
    const formatDate = (date) => {
        if (!date) return "-";

        const parts = date.split("-");

        if (parts.length === 3) {
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }

        return date;
    };
    return (
        <>
            {details.map((item, index) => (
                <div
                    key={item.id}
                    className="card mb-3 border"
                >
                    <div className="card-header bg-light">
                        <strong>
                            History #{details.length - index}
                        </strong>
                    </div>

                    <div className="card-body p-2">
                        <table className="table table-bordered table-sm mb-0">
                            <tbody>

                                <tr>
                                    <th width="25%">Call Date</th>
                                    <td>{formatDate(item?.callDate)}</td>

                                    <th width="25%">Created On</th>
                                    <td>{item?.created_on || "-"}</td>
                                </tr>

                                <tr>
                                    <th>Call Feedback</th>
                                    <td colSpan="3">
                                        {item?.callFeedback || "-"}
                                    </td>
                                </tr>

                                <tr>
                                    <th>Final Disposition</th>
                                    <td colSpan="3">
                                        {item?.finalDisposition || "-"}
                                    </td>
                                </tr>

                                <tr>
                                    <th>Remarks</th>
                                    <td colSpan="3">
                                        {item?.remarks || "-"}
                                    </td>
                                </tr>

                                <tr>
                                    <th>Created By</th>
                                    <td>
                                        {item?.createdByName || "-"}
                                    </td>

                                    <th>Lead</th>
                                    <td>
                                        {item?.leadName || "-"}{" "}
                                        {item?.leadMobile
                                            ? `(${item.leadMobile})`
                                            : ""}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </>
    );
};

export default PreEmiPopUp;